export default __webpack_public_path__ + "static/media/Carouselimage3.43d13d90.jpg";